export default "__VITE_ASSET__BgAG9En___"